var map = {
	"./address_image.svg": 128,
	"./animated_logo.svg": 129,
	"./blogs_image.svg": 130,
	"./calculator.png": 131,
	"./cloud_infrastructure.svg": 132,
	"./codeInLogo.png": 133,
	"./contactMail.png": 134,
	"./coursera_logo.png": 135,
	"./data-science-icon.svg": 136,
	"./data_science.svg": 137,
	"./datacamp.png": 138,
	"./deeplearning_ai_logo.png": 139,
	"./delhivery_logo.png": 140,
	"./developerActivity.svg": 141,
	"./dsc_logo.png": 142,
	"./education.svg": 143,
	"./experience.svg": 144,
	"./feelingProud.svg": 145,
	"./freecopy_logo.png": 146,
	"./fullstack.svg": 147,
	"./gcp_logo.png": 148,
	"./github_logo.png": 149,
	"./googleAssistant.jpg": 150,
	"./googleAssistant.svg": 151,
	"./google_logo.png": 152,
	"./ibm_logo.png": 153,
	"./intel_logo.jpg": 154,
	"./iu_logo.png": 155,
	"./jsFramework.svg": 156,
	"./legato_logo.png": 157,
	"./manOnTable.svg": 158,
	"./microsoft_logo.png": 159,
	"./mozilla_logo.png": 160,
	"./muffito_logo.png": 161,
	"./nextuLogo.jpg": 162,
	"./nptel_logo.png": 163,
	"./portfolio.gif": 164,
	"./programmer.svg": 165,
	"./projects_image.svg": 166,
	"./pwa.png": 167,
	"./saayaHealthLogo.png": 168,
	"./talksCardBack.svg": 169,
	"./talksCardBackAlt.svg": 170,
	"./tiktok_logo.png": 171,
	"./ui_ux_design.svg": 172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;